export { CustomPagination } from './src/custom-pagination';
